/**
 * 广场在线搜索音源注册表（去重后）
 *
 * 来源文件对照：
 * - 1.json：元力/小窝系列配置（kw/kg/wy/tx/mg），mg 默认 disabled
 * - 2.json 与 3.json：内容完全相同，均为 yuanli 插件 URL 列表
 * - 落雪音乐/长青SVIP音源v1.2.0.js：洛雪音乐(LX Music)插件脚本，用 Node 模拟
 *   globalThis.lx 运行环境反混淆验证后确认：其播放直链解析后端与本项目现有实现
 *   完全不同（不同域名/IP、不同路径、不同音质参数命名），因此按平台各拆成一个
 *   独立的「长青X源」音源，而不是合并进现有实现：
 *     kg: music.haitangw.cc/kgqq1/kg.php   （现有: music.haitangw.cc/music/kg_song_kw.php）
 *     tx: 175.27.166.236/kgqq1/qq.php (HTTP裸IP) （现有: music.haitangw.cc/music/qq_song_kw.php）
 *     wy: 175.27.166.236/wy1/wy.php   (HTTP裸IP) （现有: music.haitangw.cc/music/wy_song_kw.php + 网易官方回退）
 *     kw: musicapi.haitangw.net/music1/kw.php    （现有: music.haitangw.cc/music/kw_song_kw.php + cenguigui回退）
 *     mg: music.haitangw.cc/musicapi1/mg.php     （现有: 之前完全没有 mg 源，已直接采用为「小粉源」）
 *
 * 去重结论（按平台 id）：
 * - qq (tx)  ← 1.json tx + 2/3.json qq.js + 长青SVIP tx
 * - kw       ← 1.json 小窝源 + 2/3.json kw.js + 长青SVIP kw
 * - kg       ← 1.json 小狗源 + 2/3.json kg.js + 长青SVIP kg
 * - wy       ← 1.json 小云源 + 2/3.json wy.js + 长青SVIP wy
 * - bilibili ← 仅 2/3.json，偏视频内容，广场歌曲搜索暂不启用
 * - mg       ← 1.json disabled + 2/3.json xiaomi.js + 长青SVIP mg，现已启用（小粉源）
 *
 * 搜索顺序：前面的源无结果时自动尝试下一个（见 plazaMultiSourceSearch.js）
 */
export const PLAZA_MUSIC_SOURCES = [
  {
    id: 'qq',
    name: '小Q源',
    enabled: true,
    searchType: 'qq-plugin',
    pluginUrl: 'https://13413.kstore.vip/yuanli/qq.js'
  },
  {
    id: 'kw',
    name: '小窝源',
    enabled: true,
    searchType: 'kw-plugin',
    pluginUrl: 'https://13413.kstore.vip/yuanli/kw.js'
  },
  {
    id: 'kg',
    name: '小狗源',
    enabled: true,
    searchType: 'kg-plugin',
    pluginUrl: 'https://13413.kstore.vip/yuanli/kg.js'
  },
  {
    id: 'wy',
    name: '小云源',
    enabled: true,
    searchType: 'wy-plugin',
    pluginUrl: 'https://13413.kstore.vip/yuanli/wy.js'
  },
  {
    id: 'mg',
    name: '小粉源',
    enabled: true,
    searchType: 'mg-plugin',
    pluginUrl: 'https://13413.kstore.vip/yuanli/xiaomi.js'
  },
  {
    id: 'lx-qq',
    name: '长青Q源',
    enabled: true,
    autoFallback: false,
    searchType: 'lx-qq-plugin',
    pluginUrl: '落雪音乐/长青SVIP音源v1.2.0.js（tx线路，裸IP+HTTP，稳定性未知）'
  },
  {
    id: 'lx-kw',
    name: '长青窝源',
    enabled: true,
    autoFallback: false,
    searchType: 'lx-kw-plugin',
    pluginUrl: '落雪音乐/长青SVIP音源v1.2.0.js（kw线路：musicapi.haitangw.net）'
  },
  {
    id: 'lx-kg',
    name: '长青狗源',
    enabled: true,
    autoFallback: false,
    searchType: 'lx-kg-plugin',
    pluginUrl: '落雪音乐/长青SVIP音源v1.2.0.js（kg线路：music.haitangw.cc/kgqq1）'
  },
  {
    id: 'lx-wy',
    name: '长青云源',
    enabled: true,
    autoFallback: false,
    searchType: 'lx-wy-plugin',
    pluginUrl: '落雪音乐/长青SVIP音源v1.2.0.js（wy线路，裸IP+HTTP，稳定性未知）'
  }
];

export const getPlazaSourceById = (sourceId) =>
  PLAZA_MUSIC_SOURCES.find((item) => item.id === sourceId);

export const getPlazaSourceBySearchType = (searchType) =>
  PLAZA_MUSIC_SOURCES.find((item) => item.searchType === searchType);
